import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
var UpdateModelPlugin = (_dec = injectable(), _dec(_class = function () {
  function UpdateModelPlugin() {
    _classCallCheck(this, UpdateModelPlugin);
  }

  _createClass(UpdateModelPlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.beforeRender.tap('UpdateModelPlugin', function () {
        if (layer.layerModel) {
          layer.layerModel.needUpdate();
        }
      });
    }
  }]);

  return UpdateModelPlugin;
}()) || _class);
export { UpdateModelPlugin as default };
//# sourceMappingURL=UpdateModelPlugin.js.map